const displayAliases: Record<string, string> = {
  TON: "GRAM",
  MATIC: "POL",
};

const normaliseCurrencyCode = (currency: string): string => {
  return displayAliases[currency] ?? currency;
};

export default normaliseCurrencyCode;
